<template>
  <div>
    <v-toolbar v-if="acs.id">
      <v-toolbar-title>{{
        t("access_code_set.header.title", { name: acs.name })
      }}</v-toolbar-title>
    </v-toolbar>
    <v-toolbar v-else>
      <v-toolbar-title>{{
        t("access_code_set.header.create_acs")
      }}</v-toolbar-title>
    </v-toolbar>
  </div>
</template>

<script setup>
import { useI18n } from 'vue-i18n'
const { t } = useI18n()
defineProps(['acs'])
</script>
